import { Exclude } from 'class-transformer';
import { BaseItem } from './base-item.model';

export enum UserRoles {
  user = 'user',
  superAdmin = 'super-admin'
}

interface RoleAttributes {
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
}

@Exclude()
export class Role extends BaseItem<RoleAttributes> {}
